"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);



/* Each chat's scheduled messages, as the thread shows them: scheduled,
 * sending and failed-not-dismissed rows, by send time. Loaded when the chat
 * opens and kept current by the commands' responses and the
 * ScheduledMessageUpdate push. */























const initialState = {
  byConversation: {}, gone: {}, listRequest: {}, listed: {}, touched: {}, hidden: {}, timeZone: null,
}

const isShown = (row) =>
  row.Status === 'scheduled' || row.Status === 'sending' || (row.Status === 'failed' && !row.DismissedAt)

const bySendTime = (a, b) =>
  a.SendAt.localeCompare(b.SendAt) ||
  a.CreatedAt.localeCompare(b.CreatedAt) ||
  a.ScheduledMessageKey.localeCompare(b.ScheduledMessageKey)

// A push or a refusal's Current is a row only when it has the fields the
// slice keys and orders on; anything else is ignored.
const isScheduledRow = (value) => {
  if (!value || typeof value !== 'object') return false
  // SAFETY: an object; each field read is checked before it is trusted.
  const row = value 
  return typeof row.ScheduledMessageKey === 'string' &&
    typeof row.ConversationKey === 'string' &&
    typeof row.Version === 'number'
}

const upsert = (state, row) => {
  const key = row.ScheduledMessageKey
  const goneAt = state.gone[key]
  if (goneAt !== undefined && goneAt >= row.Version) return state

  const rows = state.byConversation[row.ConversationKey] || []
  const existing = rows.find(r => r.ScheduledMessageKey === key)
  if (existing && existing.Version > row.Version) return state

  const others = rows.filter(r => r.ScheduledMessageKey !== key)
  const touched = { ...state.touched, [key]: _nullishCoalesce(state.listRequest[row.ConversationKey], () => ( 0)) }
  if (isShown(row)) {
    return {
      ...state,
      byConversation: { ...state.byConversation, [row.ConversationKey]: [...others, row].sort(bySendTime) },
      touched,
    }
  }
  return {
    ...state,
    byConversation: { ...state.byConversation, [row.ConversationKey]: others },
    gone: { ...state.gone, [key]: row.Version },
    touched,
  }
}

// A list reply replaces the chat's rows, except rows a push or command wrote
// after the request went out, which the snapshot may not have seen yet.
const replaceConversation = (
  state,
  conversationKey,
  listed,
  request,
) => {
  const current = state.byConversation[conversationKey] || []
  const fromList = listed
    .filter(row => isShown(row) && !((_nullishCoalesce(state.gone[row.ScheduledMessageKey], () => ( -1))) >= row.Version))
    // A push that landed while the list was in flight is newer than the list.
    .map(row => {
      const existing = current.find(r => r.ScheduledMessageKey === row.ScheduledMessageKey)
      return existing && existing.Version > row.Version ? existing : row
    })
  const listedKeys = new Set(fromList.map(row => row.ScheduledMessageKey))
  const writtenSince = request === undefined
    ? []
    : current.filter(row =>
      !listedKeys.has(row.ScheduledMessageKey) && (_nullishCoalesce(state.touched[row.ScheduledMessageKey], () => ( -1))) >= request)
  return {
    ...state,
    byConversation: { ...state.byConversation, [conversationKey]: [...fromList, ...writtenSince].sort(bySendTime) },
  }
}

// SAFETY: listScheduledMessages puts a number here; anything else reads as none.
const listRequestOf = (meta) => {
  const value = _optionalChain([(meta ), 'optionalAccess', _ => _.ListRequest])
  return typeof value === 'number' ? value : undefined
}

 function scheduledMessagesReducer (
  state = initialState,
  action,
) {
  switch (action.type) {
    case _actionCreators2.default.listScheduledMessagesActions.REQUEST.type: {
      // SAFETY: listScheduledMessages puts the chat's key in the meta.
      const conversationKey = _optionalChain([action, 'access', _2 => _2.meta, 'optionalAccess', _3 => _3.ConversationKey]) 
      const request = listRequestOf(action.meta)
      if (!conversationKey || request === undefined) return state
      return { ...state, listRequest: { ...state.listRequest, [conversationKey]: request } }
    }

    case _actionCreators2.default.listScheduledMessagesActions.SUCCESS.type: {
      // SAFETY: as for REQUEST.
      const conversationKey = _optionalChain([action, 'access', _4 => _4.meta, 'optionalAccess', _5 => _5.ConversationKey]) 
      if (!conversationKey) return state
      const request = listRequestOf(action.meta)
      // A newer list was asked for since: its reply decides.
      if (request !== undefined && request !== state.listRequest[conversationKey]) return state
      const replaced = replaceConversation(state, conversationKey, _optionalChain([action, 'access', _6 => _6.payload, 'optionalAccess', _7 => _7.ScheduledMessages]) || [], request)
      return { ...replaced, listed: { ...replaced.listed, [conversationKey]: true } }
    }

    case _actionCreators2.default.scheduleMessageActions.SUCCESS.type:
    case _actionCreators2.default.editScheduledMessageActions.SUCCESS.type:
    case _actionCreators2.default.sendScheduledMessageNowActions.SUCCESS.type:
    case _actionCreators2.default.retryScheduledMessageActions.SUCCESS.type:
    case _actionCreators2.default.cancelScheduledMessageActions.SUCCESS.type:
    case _actionCreators2.default.dismissScheduledMessageActions.SUCCESS.type:
    case _actionCreators2.default.scheduledMessageUpdateNotificationAction.type:
      return isScheduledRow(action.payload) ? upsert(state, action.payload) : state

    // A refusal carries the row as it is now (scheduled_message_changed and
    // scheduled_message_not_scheduled).
    case _actionCreators2.default.editScheduledMessageActions.FAILURE.type:
    case _actionCreators2.default.sendScheduledMessageNowActions.FAILURE.type:
    case _actionCreators2.default.retryScheduledMessageActions.FAILURE.type:
    case _actionCreators2.default.cancelScheduledMessageActions.FAILURE.type:
    case _actionCreators2.default.dismissScheduledMessageActions.FAILURE.type: {
      // SAFETY: the payload is the raw client error; Current is checked below.
      const current = _optionalChain([(action.payload ), 'optionalAccess', _8 => _8.Current])
      return isScheduledRow(current) ? upsert(state, current) : state
    }

    case _actionCreators2.default.hideScheduledMessageAction.type: {
      // SAFETY: hideScheduledMessageAction's payload is the row's key.
      const key = action.payload 
      return state.hidden[key] ? state : { ...state, hidden: { ...state.hidden, [key]: true } }
    }

    case _actionCreators2.default.unhideScheduledMessageAction.type: {
      // SAFETY: as for hide.
      const key = action.payload 
      if (!state.hidden[key]) return state
      const hidden = { ...state.hidden }
      delete hidden[key]
      return { ...state, hidden }
    }

    case _actionCreators2.default.setScheduleTimeZoneAction.type: {
      // SAFETY: setScheduleTimeZoneAction's payload.
      const { timeZone, fromStorage } = action.payload 
      if (fromStorage && state.timeZone) return state
      return state.timeZone === timeZone ? state : { ...state, timeZone }
    }

    case _actionCreators2.default.logoutAction.type:
      return state === initialState ? state : initialState
  }
  return state
} exports.default = scheduledMessagesReducer;
